import EventDispatcher from "../../../../lib/html5-software-library/src/ranj/util/EventDispatcher";
import TaskExecutor from "../../../../lib/html5-software-library/src/ranj/util/executor/TaskExecutor";
import StartupEvent from "./StartupEvent";

export default class Startup extends TaskExecutor {

    /**
     * Extends TaskExecutor with progress and completion events.
     * @param {ITaskFactory} taskFactory 
     */
    constructor(taskFactory) {
        super(taskFactory);
        EventDispatcher.setAsDispatcher(this);
    }

    destroy() {
        super.destroy();
        this.removeAllEventListeners();
    }

    execute() {
        super.execute(this._onComplete.bind(this), this._onProgress.bind(this));
    }

    /**
     * @param {Number} perc - progress 'percentage' in range 0..1
     */
    _onProgress(perc) {        
        this.dispatchEvent(StartupEvent.PROGRESS, { progress:perc });
    }

    _onComplete() {        
        this.dispatchEvent(StartupEvent.COMPLETE);
    }

}
